export const FormatOptions = () => {
  return <section className="space-y-12">
      <div>
        <h2 className="text-[62px] font-medium mb-8">Format Options</h2>
        <ul className="list-disc pl-6 space-y-4 text-[22px] font-inter">
          <li>Keynote Presentations (45-60 minutes)</li>
          <li>Interactive Workshops (2-4 hours)</li>
          <li>Panel Moderation</li>
          <li>Fireside Chats</li>
        </ul>
      </div>

      <div>
        <h3 className="font-medium mb-4 text-6xl">Budget</h3>
        <p className="text-[22px] font-inter">€2,500 - €5,000</p>
        <p className="text-[22px] font-inter mt-2 italic">
          Travel expenses not included for events outside of Berlin.
        </p>
      </div>
    </section>;
};